<template>
  <div>
    <Counting_stock_create/>
  </div>
</template>

<script>
import Counting_stock_create from "@/components/adminArin/pos_system/warehouse/countingstock/Counting_stock_create";
export default {
  name: "countingstockcreate",
  components: {
    Counting_stock_create
  }
}
</script>

<style scoped>

</style>
